import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { KmsService } from '../../../kms.service';
declare var $;
@Component({
  selector: 'app-text-search',
  templateUrl: './text-search.component.html',
  styleUrls: ['./text-search.component.css']
})
export class TextSearchComponent implements OnInit {
  // 素材Id
  @Input() materialId: any;
  // 初始化传入的搜索关键字
  @Input() keyword:string = '';
  // 进行搜索时，搜索文字高亮：抛出事件
  @Output() keySearch = new EventEmitter();
  // 点击搜索结果跳转到指定页：抛出事件
  @Output() toPage = new EventEmitter(); 
  initSearch = true;
  // 搜索关键字
  key = '';
  // 查询结果选中项
  selectedObj = {
    index1: -1,   // 一级索引 ：页码
    index2: -1,   // 二级索引：具体哪一条数据
  }
  // 搜索结果
  results:any = [];
  total = 0;
  constructor(
    private box: SwMassageBoxService,
    private kmsService: KmsService
  ) { }

  ngOnInit() {
  }

  ngOnChanges() {
    if(this.initSearch && this.keyword){
      this.key = this.keyword;
      this.clickSearch(true);
    }
    this.initSearch = false;
  }
  
  //enter键触发搜索
  enterSearch(event) {
    if (event.keyCode == '13') {
      this.clickSearch();
    }
  }

  // 搜索
  clickSearch(init?){
    const keyVal = $.trim(this.key);
    if(keyVal){
      let params = {
        "keyword": keyVal,
        "materialId": this.materialId
      }
      this.kmsService.materialQuery(params).subscribe(res => {
        if(res.code == '200'){
          let datas = res.data ? res.data : [];
          if(datas.length == 0){
            this.results = [];
            this.box.danger('未搜索到任何相关内容！');
            return;
          }
          this.results = [];
          this.total = 0;
          datas.forEach(item => {
            if(item.matchContent){
              let matchContent = item.matchContent;
              if(matchContent.length>0){
                let menu = {
                  'pagesNum': item.pagesNum,
                  'pageStr':'第'+item.pagesNum+'页',
                  'children': [],
                  'isOpen': true
                }
                let parentId = this.results.length;
                for(let i=0;i<matchContent.length;i++){
                  let str = matchContent[i];
                  if(str){
                    str = str.replace(new RegExp(keyVal,'g')  ,'<i class="gaoliang">'+keyVal+'</i>');
                    str = str.replace('<br>','');
                  }
                  menu.children.push(
                    {
                      'id': parentId+'-'+i,
                      'positionStr': str
                    }
                  )
                  this.total += 1;
                }
                this.results.push(menu);
              }
            }
          });
          if(!init && this.results.length>0){
            this.keySearch.emit({
              keyword: keyVal,
              current: this.results[0].pagesNum
            });
          }
          this.selectedObj = {
            index1: -1,
            index2: -1
          };
        }
      });
    }else{
      this.box.danger('请输入搜索关键字！');
    }
  }

  // 重置
  clickReload(){
    this.key = '';
    this.results = [];
  }

  // 点击左侧搜索结果父节点展开或收起菜单
  toggleLi(item,i) {
    item.isOpen = !item.isOpen;
  }

  // 点击左侧搜索结果子节点进行定位
  liClick(i, j) {
    this.selectedObj = {
      index1: i,
      index2: j
    };
    this.toPage.emit(this.results[i].pagesNum);
  }
}
